import { useSearchParam } from "lib/@hooks/use-search-param"
import DemandGuard from "minimals-template/components/guards/DemandGuard"
import { FacilitiesSearch } from "routes/facilities/facilities-search"
import { RegimeList } from "routes/regime/regime-list"

export function FacilitiesEntry() {
    const [id] = useSearchParam("id")
    const [share] = useSearchParam("share")

    if (share && id === "search") {
        return (
            <DemandGuard demands="$sharing">
                <FacilitiesSearch />
            </DemandGuard>
        )
    }

    return <RegimeList />
}
